export default {
  extended: 'extended', // most protection
  none: 'none', // no protection
  stop: 'stop', // some protection
};
